import { tmrChecklistOperationController } from 'tmr/controllers/operation/checklistOperation'
import templateUrl from './transferToZone.html'
import icon from './transferToZone.svg'

/**
 * TransferToZone Operation route configuration.
 *
 * @namespace routes.OperationTransferToZoneRoute
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations.transferToZone',
  label: 'OPERATIONS.TRANSFERTOZONE.TITLE',
  url: '/transfer-to-zone',
  resolve: {
    antenna: /*@ngInject*/ ActiveWorkstation => ActiveWorkstation.getAntennas(),
    productImageEnabled: /*@ngInject*/ appConfiguration =>
      appConfiguration['product.image.enabled'],
    zones: /*@ngInject*/ (loggedUser, Zone) =>
      Zone.query({
        'place.id': loggedUser.place.id,
        zoneType: 'STOCK',
        orderBy: 'DESCRIPTION',
        asc: true,
      }).$promise,
  },
  component: 'tmrOperationTransferToZone',
  accessControl: ['Operation.perform', 'Operation.TransferToZone.perform'],
  weight: 5,
  icon,
}

/**
 * TransferToZone Operation component.
 *
 * @type {ngComponent}
 * @prop {Antenna} antenna The antenna passed by the parent operations route
 * @prop {array} zones A list of possible destination zones
 */
export const tmrOperationTransferToZone = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrOperationTransferToZoneController',
  bindings: {
    antenna: '<',
    zones: '<',
    productImageEnabled: '<',
  },
}

/**
 * Controller of component {@link tmrOperationTransferToZone}.
 *
 * @type {ngController}
 */
export class tmrOperationTransferToZoneController extends tmrChecklistOperationController {
  constructor(
    debounce,
    $mdDialog,
    TmrToast,
    TmrMovementHelper,
    TmrMovementByUpcHelper,
    TmrOperationHelper,
    MovementTransferToZone,
    Checklist,
    TmrChecklistNotFoundError
  ) {
    'ngInject'
    super(
      debounce,
      $mdDialog,
      TmrToast,
      TmrMovementHelper,
      TmrMovementByUpcHelper,
      TmrOperationHelper,
      Checklist,
      TmrChecklistNotFoundError
    )
    Object.assign(this, { MovementTransferToZone })
  }

  initVars() {
    super.initVars()
    if (this.zones.length == 1) this.zone = this.zones[0]
    this.checklistEnable = this.getConfig('ttzChecklistEnable')
  }

  /**
   * Item read event, fired by tmrAntennaControls.
   * Performs MovementTransferToZone.status requests in sequence.
   */
  onItemRead() {
    this.detailsPromise
      .then(() => {
        this.loadingStatus = true
        return this.MovementTransferToZone.status(
          this.zone,
          this.antenna.$items,
          this.description,
          this.packageCode,
          this.checklist
        ).$promise.then(
          details => this.buildGroupsDebounce(details),
          err =>
            this.TmrMovementHelper.statusError(err, this.antenna, this.onClear)
        )
      })
      .finally(() => (this.loadingStatus = false))
  }

  onConfirm() {
    super.onConfirm()
    return this.MovementTransferToZone.transfer(
      this.zone,
      this.antenna.$items,
      this.description,
      this.packageCode,
      this.checklist
    )
      .$promise.then(
        () => this.transferSuccess(),
        err => this.TmrToast.exception(err)
      )
      .finally(() => this.onConfirmed())
  }

  transferSuccess() {
    this.TmrToast.success(
      'OPERATIONS.TRANSFERTOZONE.SUCCESS',
      { COUNT: this.antenna.$items.length },
      'messageformat'
    )
    this.packageCode = ''
    this.checklist = null
    this.onClear()
  }

  onChecklistChange(isOn, onValue) {
    this.packageCode = onValue
    this.setConfig('ttzChecklistEnable', isOn)
    super.onChecklistChange(isOn)
  }
}
